module.exports = __webpack_public_path__ + "static/media/background-bot.75578638.png";